import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const AUDIO_SETTINGS_EVENT_NAMES = {
  TOGGLE_SOUND: 'sound_notifications_turned',
  TOGGLE_REPEAT_ALERT_SOUND: 'repeat_sound_notifications_toggle_turned',
  CHANGE_AUDIO_TONE: 'audio_tone_changed',
  AUDIO_TONE_PREVIEWED: 'audio_tone_previewed',
  CHANGE_TT911_REPEAT_TIMES: 'tt911_repeat_times_changed',
};

export const trackToggleSoundOnOff = (irpVersion, soundOnStatus, type) => {
  const soundStatus = soundOnStatus ? 'Off' : 'On';
  gspx.trackEvent({
    name: AUDIO_SETTINGS_EVENT_NAMES.TOGGLE_SOUND,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: `Sound Notifications for ${type} were turned ${soundStatus}`,
      Category: 'Admin Settings',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackToggleRepeatAlertSound = (irpVersion, soundOnStatus) => {
  const soundStatus = soundOnStatus ? 'Off' : 'On';
  gspx.trackEvent({
    name: AUDIO_SETTINGS_EVENT_NAMES.TOGGLE_REPEAT_ALERT_SOUND,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: `Repeat Sound Notifications toggle for Alerts was turned ${soundStatus}`,
      Category: 'Admin Settings',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackChangeAudioTone = (irpVersion, type) => {
  gspx.trackEvent({
    name: AUDIO_SETTINGS_EVENT_NAMES.CHANGE_AUDIO_TONE,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: `The Audio Tone for ${type} was changed`,
      Category: 'Admin Settings',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackAudioTonePreviewed = (irpVersion, toneName) => {
  gspx.trackEvent({
    name: AUDIO_SETTINGS_EVENT_NAMES.AUDIO_TONE_PREVIEWED,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: `The ${toneName} Audio Tone was pre-viewed`,
      Category: 'Admin Settings',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackChangeTT911RepeatTimes = (irpVersion, repeatTimes) => {
  gspx.trackEvent({
    name: AUDIO_SETTINGS_EVENT_NAMES.CHANGE_TT911_REPEAT_TIMES,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: `Repeat Times for TT911 was changed to ${repeatTimes} times`,
      Category: 'Admin Settings',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};
